var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.00027C10.6181 3.00027 11.2223 3.18355 11.7362 3.52693C12.2501 3.87031 12.6506 4.35837 12.8871 4.92939C13.1236 5.50041 13.1855 6.12874 13.065 6.73493C12.9444 7.34112 12.6467 7.89794 12.2097 8.33498C11.7727 8.77202 11.2158 9.06965 10.6097 9.19023C10.0035 9.31081 9.37513 9.24892 8.80411 9.0124C8.2331 8.77587 7.74504 8.37534 7.40166 7.86143C7.05828 7.34753 6.875 6.74334 6.875 6.12527C6.875 5.29647 7.20424 4.50162 7.79029 3.91557C8.37634 3.32951 9.1712 3.00027 10 3.00027ZM10 1.75027C9.13471 1.75027 8.28885 2.00686 7.56938 2.4876C6.84992 2.96833 6.28916 3.65161 5.95803 4.45103C5.62689 5.25046 5.54025 6.13013 5.70906 6.97879C5.87787 7.82746 6.29455 8.60701 6.90641 9.21887C7.51826 9.83072 8.29781 10.2474 9.14648 10.4162C9.99515 10.585 10.8748 10.4984 11.6742 10.1672C12.4737 9.83611 13.1569 9.27536 13.6377 8.55589C14.1184 7.83643 14.375 6.99057 14.375 6.12527C14.375 4.96495 13.9141 3.85215 13.0936 3.03168C12.2731 2.21121 11.1603 1.75027 10 1.75027ZM16.25 20.5003H15V17.3753C15 16.9649 14.9192 16.5585 14.7621 16.1794C14.6051 15.8002 14.3749 15.4557 14.0847 15.1656C13.7945 14.8754 13.45 14.6452 13.0709 14.4882C12.6917 14.3311 12.2854 14.2503 11.875 14.2503H8.125C7.2962 14.2503 6.50134 14.5795 5.91529 15.1656C5.32924 15.7516 5 16.5465 5 17.3753V20.5003H3.75V17.3753C3.75 16.215 4.21094 15.1022 5.03141 14.2817C5.85188 13.4612 6.96468 13.0003 8.125 13.0003H11.875C13.0353 13.0003 14.1481 13.4612 14.9686 14.2817C15.7891 15.1022 16.25 16.215 16.25 17.3753V20.5003Z",
    fill: "#2E375B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68384 20.0003L18.6042 20.0003",
    stroke: "#2E375B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.500275)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonUserInfo);
export default __webpack_public_path__ + "static/media/carbonUserInfo.c02f1a8c27dd969037827d0df8597c45.svg";
export { ForwardRef as ReactComponent };